import React from "react";
import { Grid, Loader } from "@pushpress/shared-components";
import Dashboard from "./../layouts/Dashboard";

const ContentLoading = () => {
  return (
    <Dashboard>
      <Grid container justifyContent="center" alignItems="center">
        <Grid item>
          <Loader />
        </Grid>
      </Grid>
    </Dashboard>
  );
};

export default ContentLoading;
